export enum SendersEnum {
  Sacado = 1,
  Cedente = 2,
  Desconhecido = 3,
}
